import * as React from "react";

const IconTableReorder: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="8" height="11" viewBox="0 0 8 11" fill="currentColor"><path fill="currentColor" d="M3.75,0 L0,3.375 L0,4.5 L7.5,4.5 L7.5,3.375 L3.75,0 Z M3.75,10.5 L7.5,7.125 L7.5,6 L0,6 L0,7.125 L3.75,10.5 Z" transform="translate(.25 .25)"/></svg>;
};

export default React.memo(IconTableReorder);
